'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lcom_raquo_laminar_keys_SvgAttr$() {
  this.R8 = null;
  this.R9 = null;
  this.Ra = null;
  this.Rb = null;
  this.R8 = "http://www.w3.org/2000/svg";
  this.R9 = "http://www.w3.org/1999/xlink";
  this.Ra = "http://www.w3.org/XML/1998/namespace";
  this.Rb = "http://www.w3.org/2000/xmlns/";
}
export { $c_Lcom_raquo_laminar_keys_SvgAttr$ as $c_Lcom_raquo_laminar_keys_SvgAttr$ };
$p = $c_Lcom_raquo_laminar_keys_SvgAttr$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lcom_raquo_laminar_keys_SvgAttr$;
/** @constructor */
function $h_Lcom_raquo_laminar_keys_SvgAttr$() {
}
export { $h_Lcom_raquo_laminar_keys_SvgAttr$ as $h_Lcom_raquo_laminar_keys_SvgAttr$ };
$h_Lcom_raquo_laminar_keys_SvgAttr$.prototype = $p;
$p.Wd = (function(namespace) {
  switch (namespace) {
    case "svg": {
      return "http://www.w3.org/2000/svg";
      break;
    }
    case "xlink": {
      return "http://www.w3.org/1999/xlink";
      break;
    }
    case "xml": {
      return "http://www.w3.org/XML/1998/namespace";
      break;
    }
    case "xmlns": {
      return "http://www.w3.org/2000/xmlns/";
      break;
    }
    default: {
      throw new $j_java$002elang$002e$002dObject.$c_s_MatchError(namespace);
    }
  }
});
var $d_Lcom_raquo_laminar_keys_SvgAttr$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lcom_raquo_laminar_keys_SvgAttr$, "com.raquo.laminar.keys.SvgAttr$", ({
  io: 1
}));
export { $d_Lcom_raquo_laminar_keys_SvgAttr$ as $d_Lcom_raquo_laminar_keys_SvgAttr$ };
var $n_Lcom_raquo_laminar_keys_SvgAttr$;
function $m_Lcom_raquo_laminar_keys_SvgAttr$() {
  if ((!$n_Lcom_raquo_laminar_keys_SvgAttr$)) {
    $n_Lcom_raquo_laminar_keys_SvgAttr$ = new $c_Lcom_raquo_laminar_keys_SvgAttr$();
  }
  return $n_Lcom_raquo_laminar_keys_SvgAttr$;
}
export { $m_Lcom_raquo_laminar_keys_SvgAttr$ as $m_Lcom_raquo_laminar_keys_SvgAttr$ };
